import { NavigationComponent } from "./NavigationComponent";
export default NavigationComponent;